import React from 'react';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalBody,
  IconButton,
  useColorModeValue,
} from '@chakra-ui/react';
import { FiX, FiChevronLeft, FiChevronRight } from 'react-icons/fi';

const ModalVisualizarImagens = ({
  isOpen,
  onClose,
  imagens,
  indiceAtual,
  setIndiceAtual,
}) => {
  const bgModal = useColorModeValue('white', 'gray.900');
  const corIcone = useColorModeValue('gray.800', 'white');
  const bgIcon = useColorModeValue('blackAlpha.100', 'whiteAlpha.100');
  const bgIconHover = useColorModeValue('blackAlpha.200', 'whiteAlpha.200');

  if (!imagens || imagens.length === 0) return null;
  const imagemAtual = imagens[indiceAtual];

  const avancar = () => setIndiceAtual(prev => (prev + 1) % imagens.length);
  const voltar = () =>
    setIndiceAtual(prev => (prev - 1 + imagens.length) % imagens.length);

  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered size="xl">
      <ModalOverlay backdropFilter="blur(4px)" />
      <ModalContent bg={bgModal} color={corIcone} maxW="70vw" py={10}>
        <IconButton
          aria-label="Fechar"
          icon={<FiX />}
          position="absolute"
          right={2}
          top={2}
          zIndex={3}
          variant="ghost"
          color={corIcone}
          onClick={() => {
            setIndiceAtual(0);
            onClose();
          }}
        />
        <ModalBody
          p={0}
          display="flex"
          alignItems="center"
          justifyContent="center"
          position="relative"
        >
          <IconButton
            aria-label="Anterior"
            icon={<FiChevronLeft />}
            position="absolute"
            left={2}
            top="50%"
            transform="translateY(-50%)"
            onClick={voltar}
            zIndex={2}
            variant="ghost"
            size="lg"
            bg={bgIcon}
            _hover={{ bg: bgIconHover }}
          />
          <img
            src={imagemAtual.url}
            alt="Visualização"
            style={{
              maxHeight: '60vh',
              maxWidth: '80vw',
              width: 'auto',
              height: 'auto',
              margin: '0 auto',
              display: 'block',
              borderRadius: '8px',
            }}
          />
          <IconButton
            aria-label="Próxima"
            icon={<FiChevronRight />}
            position="absolute"
            right={2}
            top="50%"
            transform="translateY(-50%)"
            onClick={avancar}
            zIndex={2}
            variant="ghost"
            size="lg"
            bg={bgIcon}
            _hover={{ bg: bgIconHover }}
          />
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default ModalVisualizarImagens;
